import { AppConfig } from "../types";

const AppConfigDefault: AppConfig = {
  title: "Route Mapper",
  cssPath: null,
  disableGATracking: false,
  language: "en",
  version: 0.1,
  serviceRoute: "/RMServices/",
  customerValidateFailureUrl: "http://www.oag.com",
  cssVersion: "app",
  validationType: null,
  layout: "flightfinder",
  customerType: {
    airline: true,
    airport: false,
    airlineVersion: {
      single: false,
      multi: true,
      alliance: false,
      airline: null,
    },
    airportVersion: {
      single: false,
      multi: false,
      airport: null,
      airports: [],
    },
  },
  analytics: {
    google: { ga: "UA-59938408-1" },
  },
  airportsFilter: [],
  airportsFilterOut: [],
  airportMarkerFilter: false,
  urls: {
    directMarkers: "ConnectionBuilder/DirectMarkers.ashx", //'connection-builder/direct-markers',
    directMarkersAirport: "ConnectionBuilder/DirectMarkersAirport.ashx",
    connectionMarkersAirport: "ConnectionBuilder/ConnectionMarkersAirport.ashx",
    connnectionBuilderDirects: "ConnectionBuilder/Directs.ashx",
    connectionBuilderConnections: "ConnectionBuilder/Connections.ashx",
    validate: "ApplicationCustomer/Validate.ashx",
    findAirportBoundsViewportIataPattern:
      "GoogleGeocoder/FindAirportBoundsViewportIataPattern.ashx",
    findAirportBoundsViewport: "GoogleGeocoder/FindAirportBoundsViewport.ashx",
    capaValidation: "Capa/Validate.ashx",
    preferredAirline: "ConnectionBuilder/PreferredAirlines.ashx",
    automcomplete: "Autocomplete.ashx",
  },
};

export default AppConfigDefault;
